import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { registerServiceWorker } from "../service_worker_registration"

// When connected, registers a service worker.
// @see https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
export default class extends Controller {

  connect() {
    Loggable(this, { debug: false })
    this.registerServiceWorker()
  }

  registerServiceWorker(){
    this.log("registering service worker")
    return registerServiceWorker()
      .then(registration => {
        if (!registration) {
          this.log("service worker not supported")
          return
        }

        this.log("service worker registered")
        this.log(registration)
      }).catch(error => {
        this.error("service worker registration failed")
        this.error(error)
      })
  }

  unregisterServiceWorkers(){
    if (!navigator.serviceWorker) {
      this.log("service worker not supported")
      return
    }

    this.log("unregistering service worker")
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations.forEach(registration => {
          this.log("unregistering service worker")
          registration.unregister()
            .then(success => {
              this.log("service worker unregistered")
            }).catch(error => {
            this.error("service worker unregistration failed")
            this.error(error)
          })
        })
      }).catch(error => {
      this.error("service worker unregistration failed")
      this.error(error)
    })
  }


}
